import { getHistoryMessage } from 'automation-ui-log-events/records/LogEvent/contextMapUtils';
export const getLogEventMessage = logEvent => {
  const translatedMessage = getHistoryMessage(logEvent);
  if (translatedMessage) {
    return translatedMessage;
  }
  return undefined;
};